export default __webpack_public_path__ + "static/media/cards_flips_4.6089022c.mp3";